import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { IDecodeData } from 'src/common/interfaces/dtos/IEwic';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';
import { EwicDecodePrescriptionDto } from '../ewic-decode-prescription';

export const eWicDecodePrescription = async (
  data: EwicDecodePrescriptionDto,
): Promise<IDecodeData> => {
  const axiosConfig: AxiosRequestConfig = {
    url: `/ewic/decode-prescription`,
    method: 'POST',
    data: data,
  };
  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
    spanOptions: { name: 'post-decode-prescription' },
  };

  return await emeraldRequest<IDecodeData>(emeraldRequestParams);
};
